import { call } from '../@';

export type SearchPropertyByUprnDto = { uprn: number };
export type SearchPropertyByUprnResponse = { id: string | null };

const searchPropertyByUprn = async (payload: SearchPropertyByUprnDto) => call('property-searchByUprn', payload);

export default searchPropertyByUprn;
